// components
import maAdminView from '../adminView'
import maFilters from '../../components/filters'
import maPaginator from '@/components/paginator'
import maModal from '@/components/modal'
import maInputText from '@/components/input/modules/text'
import maInputSelect from '@/components/input/modules/select'
import maEmpty from '@/components/empty'

// api
import { apiGetAdminUserCompanies } from '@/services/API/admin'

import {
  apiGetAdminUserLimits,
  apiPatchAdminUserLimits,
  apiDeleteAdminUserLimits
} from '@/services/API/adminGag'

export default {
  name: 'userLimits',
  data: function () {
    return {
      userLimits: {
        user: null,
        hour_price_max_limit: null,
        hour_price_min_limit: null
      },
      companyFilter: '',
      companies: []
    }
  },
  extends: maAdminView,
  components: {
    maPaginator,
    maFilters,
    maModal,
    maInputText,
    maInputSelect,
    maEmpty
  },
  methods: {
    handleSearch: function () {
      apiGetAdminUserLimits(this.currentPage, this.companyFilter)
        .then(ajustage => {
          this.table = ajustage.results
          this.totalPages = ajustage.total_pages || 0
        })
    },
    handleEdit: function (data) {
      this.userLimits = data
      this.$refs.adminGagEditModal.showModal = true
    },
    handleDelete: function (data) {
      apiDeleteAdminUserLimits(data).then(() => {
        this.handleSearch()
        this.throwNotification(this.$t('notifications.paramChanged.title'), this.$t('notifications.paramChanged.body'), 'OK')
      })
    },
    handleSave: function () {
      apiPatchAdminUserLimits(this.userLimits)
        .then(() => {
          this.handleSearch()
          this.throwNotification(this.$t('notifications.paramChanged.title'), this.$t('notifications.paramChanged.body'), 'OK')
          this.$refs.adminGagEditModal.showModal = false
        })
        .catch((error) => {
          let hasCustomError = error.response && error.response.data && error.response.data.non_field_errors

          if (hasCustomError) {
            this.throwNotification(this.$t('notifications.error.0.title'), error.response.data.non_field_errors[0], 'KO')
            return
          }

          this.throwNotification(this.$t('notifications.error.0.title'), this.$t('notifications.error.0.body'), 'KO')
        })
    },
    filterByCompanyId: function (companyId) {
      this.companyFilter = companyId
      this.handleSearch()
    },
    resetEditValues: function () {
      if (this.userLimits) {
        Object.keys(this.userLimits).forEach(item => (item = null))
      }
    }
  },
  mounted: function () {
    apiGetAdminUserCompanies().then(data => (this.companies = data))
  }
}
